'use strict'
import {bootstrap} from '../bootstrap/bootstrap'
import * as utils from './utils'

const wizardNav = document.querySelector('nav.wizard__nav')

bootstrap(wizardNav, wizardNav => {
  const wizardMobileNavDropdown = document.querySelector('.wizard__nav--dropdown select')
  const wizardNavAnchors = wizardNav.querySelectorAll('a.tab')
  const wizardCards = document.querySelectorAll('.wizard .card')

  bootstrap(wizardNavAnchors, wizardNavAnchors => {
    Array.prototype.forEach.call(wizardNavAnchors, utils.attachNavHandlers)
  })
  bootstrap(wizardMobileNavDropdown, el => {
    utils.attachMobileNavHandlers(el)
  })
  bootstrap(wizardCards, wizardCards => {
    Array.prototype.forEach.call(wizardCards, utils.attachCardHandlers)
  })
})
